// extracted by mini-css-extract-plugin
export default {"container":"AppHeaderCarrierUser_container_nMbc7","name":"AppHeaderCarrierUser_name_jxw6a","icon":"AppHeaderCarrierUser_icon_oahkd","company":"AppHeaderCarrierUser_company_S4VUT"};